"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AppHeader_module_css_1 = __importDefault(require("./styles/AppHeader.module.css"));
const AppHeader = ({ title, align = "center" }) => {
    const getContainerStyles = () => {
        switch (align) {
            case "left": {
                return `${AppHeader_module_css_1.default.left} d-flex align-items-center`;
            }
            case "center": {
                return "app-header-container d-flex justify-content-center align-items-center";
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: getContainerStyles() }, { children: (0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "app-header-container__title" }, { children: title })) })));
};
exports.default = AppHeader;
